import $ from 'jquery';
import { formatDistanceToNow } from 'date-fns';

const connector = require('./connector.js');
const cookie = require('./cookie.js');

var $container;
var $globalFileInput;

function init(fileUploadContainerClass, fileUploadButton) {

    // Find the container and button elements
    $container = $(fileUploadContainerClass);
    const $button = $(fileUploadButton);

    enableDragAndDrop();
    fetchFiles();
    listeners();

    // Create a hidden file input element
    var $fileInput = $('#ffl-checkout-by-ttg-file-box-input');

    $button.on('click', () => {
        $fileInput.trigger('click');
    });

    $("body").on('change', '#ffl-checkout-by-ttg-file-box-input', $fileInput, (event) => {
        const file = event.target.files[0];

        if (file) {
            handleFile(file); // Pass the file to your processing function
        }
    });

    $globalFileInput = $fileInput;
}

function fetchFiles(selectLast = false) {

    connector.hideSOTUploadOptions();

    $.ajax({
        url: FFLCheckoutByTTG_FFLCheckoutApi.url + "/api/ffl/uploads/get",
        type: 'GET',
        headers: {
            'clientIdentifier': cookie.getUniqueIdCookie(),
            'd': FFLCheckoutByTTG_FFLCheckoutApi.d
        },
        dataType: 'json',
        success: function(response) {

            $container.html("");
            updateShippingFields("", "")

            if (response.files && response.files.length > 0) {

                $.each(response.files, function(index, file) {

                    let date = new Date(file.date);
                    //let humanReadableDate = formatDistanceToNow(date, { addSuffix: true });

                    const fileItem = $(`
                        <div class="ffl-checkout-by-ttg-file-item" data-license-number="${file.license_number}" data-sot-on-file="${file.ffl_details?.sot_on_file ? 'true' : 'false'}" data-file-url="${file.file_url}" data-address="${file.ffl_details?.premises_address ?? ''}" data-city="${file.ffl_details?.premises_city ?? ''}" data-state="${file.ffl_details?.premises_state ?? ''}" data-zip-code="${file.ffl_details?.premises_zip_code ?? ''}">
                            <div class="ffl-checkout-by-ttg-file-icon">📄</div>
                            <div class="ffl-checkout-by-ttg-license-name" style="display:flex; flex-direction:column; align-items:flex-start;">
                                <span style="text-align: start;"><b>${file.ffl_details?.business_name ?? (file.ffl_details?.holder_name ?? file.file_name)}</b></span>
                                <div style="width:100%; display:flex; flex-direction:row; justify-content:space-between;align-items:flex-start;">
                                    <span>${file.ffl_details?.formatted_license_number ?? file.license_number }</span>
                                    <div>
                                        <a href="${FFLCheckoutByTTG_FFLCheckoutApi.url + "/api/ffl/uploads/download/" + file.file_id}?clientIdentifier=${cookie.getUniqueIdCookie()}" target="_blank" class="ffl-checkout-by-ttg-open-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" style="width: 12px;height: 12px; fill: #fff;" id="Layer_1" x="0px" y="0px" viewBox="0 0 122.6 122.88" style="enable-background:new 0 0 122.6 122.88" xml:space="preserve"> <g> <path d="M110.6,72.58c0-3.19,2.59-5.78,5.78-5.78c3.19,0,5.78,2.59,5.78,5.78v33.19c0,4.71-1.92,8.99-5.02,12.09 c-3.1,3.1-7.38,5.02-12.09,5.02H17.11c-4.71,0-8.99-1.92-12.09-5.02c-3.1-3.1-5.02-7.38-5.02-12.09V17.19 C0,12.48,1.92,8.2,5.02,5.1C8.12,2,12.4,0.08,17.11,0.08h32.98c3.19,0,5.78,2.59,5.78,5.78c0,3.19-2.59,5.78-5.78,5.78H17.11 c-1.52,0-2.9,0.63-3.91,1.63c-1.01,1.01-1.63,2.39-1.63,3.91v88.58c0,1.52,0.63,2.9,1.63,3.91c1.01,1.01,2.39,1.63,3.91,1.63h87.95 c1.52,0,2.9-0.63,3.91-1.63s1.63-2.39,1.63-3.91V72.58L110.6,72.58z M112.42,17.46L54.01,76.6c-2.23,2.27-5.89,2.3-8.16,0.07 c-2.27-2.23-2.3-5.89-0.07-8.16l56.16-56.87H78.56c-3.19,0-5.78-2.59-5.78-5.78c0-3.19,2.59-5.78,5.78-5.78h26.5 c5.12,0,11.72-0.87,15.65,3.1c2.48,2.51,1.93,22.52,1.61,34.11c-0.08,3-0.15,5.29-0.15,6.93c0,3.19-2.59,5.78-5.78,5.78 c-3.19,0-5.78-2.59-5.78-5.78c0-0.31,0.08-3.32,0.19-7.24C110.96,30.94,111.93,22.94,112.42,17.46L112.42,17.46z" /> </g></svg>
                                        </a>
                                        <a data-delete-file-id="${file.file_id}" class="ffl-checkout-by-ttg-delete-button ffl-checkout-by-ttg-margin-left-5px">
                                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 110.61 122.88" style="width: 12px;height: 12px; fill: #fff;"> <title>trash</title> <path d="M39.27,58.64a4.74,4.74,0,1,1,9.47,0V93.72a4.74,4.74,0,1,1-9.47,0V58.64Zm63.6-19.86L98,103a22.29,22.29,0,0,1-6.33,14.1,19.41,19.41,0,0,1-13.88,5.78h-45a19.4,19.4,0,0,1-13.86-5.78l0,0A22.31,22.31,0,0,1,12.59,103L7.74,38.78H0V25c0-3.32,1.63-4.58,4.84-4.58H27.58V10.79A10.82,10.82,0,0,1,38.37,0H72.24A10.82,10.82,0,0,1,83,10.79v9.62h23.35a6.19,6.19,0,0,1,1,.06A3.86,3.86,0,0,1,110.59,24c0,.2,0,.38,0,.57V38.78Zm-9.5.17H17.24L22,102.3a12.82,12.82,0,0,0,3.57,8.1l0,0a10,10,0,0,0,7.19,3h45a10.06,10.06,0,0,0,7.19-3,12.8,12.8,0,0,0,3.59-8.1L93.37,39ZM71,20.41V12.05H39.64v8.36ZM61.87,58.64a4.74,4.74,0,1,1,9.47,0V93.72a4.74,4.74,0,1,1-9.47,0V58.64Z"></path></svg> 
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `);

                    $container.append(fileItem);
                    
                    if ((index + 1) == response.files.length && selectLast) {
                        fileItem.click();
                    }
                });
            } else {

                $container.html("<span class='ffl-checkout-by-ttg-empty-message'>Click on 'Upload a new FFL license' or drag and drop a file into this box.</span>");
            }
        },
        error: function(jqXHR, textStatus, errorThrown) {
           alert("There was an error trying to get saved FFL files, contact the website admin")
        }
    });
}

function removeSelected() {

    $(".ffl-checkout-by-ttg-file-item").removeClass("selected");
    updateShippingFields("", "")
    connector.hideSOTUploadOptions();
    connector.changeShippingValues("", "", "", "", "");
} 

function listeners() {

    $container.on("click", ".ffl-checkout-by-ttg-file-item", function() {

        // Remove 'selected' class from all other items
        $(".ffl-checkout-by-ttg-file-item").removeClass("selected");
    
        // Add 'selected' class to the clicked file item
        $(this).addClass("selected");

        // Optional: You can store or log the selected file's URL
        const selectedFileUrl = $(this).data("file-url");
        const selectedFileLicense = $(this).data("license-number");

        const premisesAddress = $(this).data("address");
        const premisesCity = $(this).data("city");
        const premisesState = $(this).data("state");
        const premisesZipCode = $(this).data("zip-code");

        let sotOptionInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_option_sot');

        if (connector.isSOTUploadEnabled()) {

            if ($(this).data("sot-on-file")) {
                connector.hideSOTUploadOptions();
                connector.changeValue(sotOptionInput, 'sot_on_file');
                $("#shipping_ffl_ttg_option_sot").val('sot_on_file');
            } else {
                connector.changeValue(sotOptionInput, '');
                $("#shipping_ffl_ttg_option_sot").val('')
                connector.showSOTUploadOptions(true);
            }
        } 

        updateShippingFields(selectedFileUrl, selectedFileLicense)
        
        if (premisesAddress != null && premisesAddress.length > 0) {
            connector.changeShippingValues(premisesAddress, "", premisesCity, premisesState, premisesZipCode);
            return;
        }
        
        connector.changeShippingValues("", "", "", "", "");
    });

    $container.on("click", "[data-delete-file-id]", function() {

        let fileId = $(this).data('delete-file-id');

        if (confirm("Are you sure that you want to delete this FFL License?") == true) {
            deleteFile(fileId);
        }
    });
}

function updateShippingFields(fileUrl, fileLicense) {
    
    // Update using jQuery
    $("input[name='shipping_ffl_ttg_license_file']").val(fileUrl);
    $("input[name='shipping_ffl_ttg_license_number']").val(fileLicense);

    // Update using React version
    let fflLicenseFile = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_license_file');
    connector.changeValue(fflLicenseFile, fileUrl);

    let fflLicenseNumber = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_license_number');
    connector.changeValue(fflLicenseNumber, fileLicense);
}

function deleteFile(fileId) {

    $.ajax({
        url: FFLCheckoutByTTG_FFLCheckoutApi.url + "/api/ffl/uploads/delete",
        type: 'POST',
        headers: {
            'clientIdentifier': cookie.getUniqueIdCookie(),
            'd': FFLCheckoutByTTG_FFLCheckoutApi.d
        },
        data: {
            file_id: fileId
        },
        success: function(response) {
            
            if (!response.success) {
                alert("ERROR: " + response.message);
                return;
            }

            fetchFiles(false);
            alert(response.message);
        },
        error: function(jqXHR, textStatus, errorThrown) {
            alert('File deletion failed: ' + errorThrown);
        }
    });
}

function uploadFile(file, fflNumber) {

    $container.parent().find(".ffl-checkout-by-ttg-loading-box").addClass("active");

    let formData = new FormData();
        formData.append('file', file);
        formData.append('license_number', fflNumber);

    $.ajax({
        url: FFLCheckoutByTTG_FFLCheckoutApi.url + "/api/ffl/uploads/upload",
        type: 'POST',
        headers: {
            'clientIdentifier': cookie.getUniqueIdCookie(),
            'd': FFLCheckoutByTTG_FFLCheckoutApi.d
        },
        data: formData,
        contentType: false,
        processData: false,
        success: function(response) {
            
            if (!response.success) {
                alert(response.message);
                return;
            }

            fetchFiles(true);
            $container.parent().find(".ffl-checkout-by-ttg-loading-box").removeClass("active");
        },
        error: function(jqXHR, textStatus, errorThrown) {
            removeLoadingForUploadButton(uploadButonStart);
            alert('File upload failed: ' + errorThrown);
        }
    });
}

function enableDragAndDrop() {

    // Drag-and-drop functionality
    $container.on('dragover', (event) => {
        event.preventDefault();
        event.stopPropagation();
        $container.addClass('dragging'); // Add dragging class for animation
    });

    $container.on('dragleave', (event) => {
        event.preventDefault();
        event.stopPropagation();
        $container.removeClass('dragging'); // Remove dragging class
    });

    $container.on('drop', (event) => {
        event.preventDefault();
        event.stopPropagation();
        $container.removeClass('dragging'); // Remove dragging class
        const files = event.originalEvent.dataTransfer.files;
        if (files.length > 0) {
            handleFile(files[0]); // Pass the first file to the processing function
        }
    });
}

// Example file handling function
function handleFile(file) {

    if (!validateFile(file)) {
        $globalFileInput.val("")
        return;
    }

    let fflNumber = askForFFLLicenseNumber();

    if (fflNumber == false) {
        $globalFileInput.val("")
        alert("FFL License file upload canceled")
        return;
    }

    uploadFile(file, fflNumber);
    $globalFileInput.val("")
}

/**
 * Validate an ATF FFL
 *
 * This function checks if the provided FFL (Federal Firearms License) number is valid based on format
 * and basic rules. The FFL number must be 15 digits long and have a valid license type.
 *
 * @param {string} licenseNumber The 15-digit FFL number to be validated.
 * @param {boolean} onlyCandr If true, only validate for Type 03: Collector.
 * @return {boolean} Returns true if the FFL number is valid, false otherwise.
 */
function isValidATFLicenseNumber(licenseNumber, onlyCandr = false) {

    // Remove non-alphanumeric characters
    licenseNumber = licenseNumber.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    if (licenseNumber.length != 15) {
        return;
    }

    const licenseTypes = {
        1: 'Type 01: Firearm Dealer/Gunsmith',
        2: 'Type 02: Pawnbroker',
        3: 'Type 03: Collector',
        6: 'Type 06: Manufacturer of Ammunition',
        7: 'Type 07: Manufacturer of Firearms',
        8: 'Type 08: Importer of Firearms',
        9: 'Type 09: Dealer of "Destructive Devices"',
        10: 'Type 10: Manufacturer of "Destructive Devices"',
        11: 'Type 11: Importer of "Destructive Devices"'
    };

    if (onlyCandr) {
        licenseTypes = { 3: 'Type 03: Collector' };
    }

    const months = {
        'A': 'January', 'B': 'February', 'C': 'March', 'D': 'April', 'E': 'May', 'F': 'June',
        'G': 'July', 'H': 'August', 'J': 'September', 'K': 'October', 'L': 'November', 'M': 'December'
    };

    // Fifth section: License type
    const licenseTypeDigit = parseInt(licenseNumber.substring(6, 8), 10);
    if (!licenseTypes[licenseTypeDigit]) {
        return false;
    }

    // Sixth section: Expiration date
    const monthLetter = licenseNumber[9];
    if (!months[monthLetter]) {
        return false;
    }

    return true;
}

function askForFFLLicenseNumber() {

    let fflNumber;

    // Keep prompting until a valid FFL number is entered
    while (true) {

        fflNumber = prompt("Enter your FFL license number (15 digits or format XX-XXXXX-XXXXXX-X):");

        if (fflNumber === null || fflNumber.length == 0) {
            return false; 
        }

        if (isValidATFLicenseNumber(fflNumber)) {
            return fflNumber;
        }
        
        alert("Invalid FFL license number format. Please enter a valid number.");
    }
}

function validateFile(file) {

    let validTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    let maxSize = 10 * 1024 * 1024; // 10 MB

    if (validTypes.includes(file.type) && file.size <= maxSize) {} else {
        alert('Invalid file. Please upload a PDF, JPG, or PNG file no larger than 10MB.');
        return false;
    }

    return true;
}


export { init, removeSelected };
